import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useQueries } from '@hero/hooks';
import { useGetCollections } from '@hero/services';

import { CustomFilter } from '../CustomFilter';

function CollectionFilter() {
  const { t } = useTranslation();

  const [render, setRender] = useState(0);

  const { addQueries, queries } = useQueries();
  const { collectionIds = [] } = queries;

  const { data: featuredCollection } = useGetCollections(
    {
      pagination: {
        page: 1,
        limit: 50
      },
      filters: {
        isPublic: true
      }
    },
    {
      onSuccess: () => setRender(prev => prev + 1)
    }
  );

  const { data: savedCollections } = useGetCollections(
    {
      pagination: {
        page: 1,
        limit: 50
      },
      filters: {
        isPublic: false
      }
    },
    {
      onSuccess: () => setRender(prev => prev + 1)
    }
  );

  const savedCollectionsOptions = savedCollections?.docs.map(collection => ({
    value: collection.id,
    label: collection.name,
    image: collection?.products?.[0]?.images?.[0]?.url
  }));

  const featuredCollectionsOptions = featuredCollection?.docs.map(collection => ({
    value: collection.id,
    label: collection.name,
    image: collection?.products?.[0]?.images?.[0]?.url
  }));

  const [selectedOptions, setSelectedOptions] = useState([]);

  useEffect(() => {
    const defaultSelectedOptions = savedCollectionsOptions
      ?.concat(featuredCollectionsOptions)
      ?.filter(o => collectionIds.includes(o?.value));
    setSelectedOptions(defaultSelectedOptions);
  }, [render, JSON.stringify(collectionIds)]);

  return (
    <CustomFilter
      creatable={false}
      size="md"
      placeholder={t('allCollections')}
      options={[
        { label: t('savedCollections'), options: savedCollectionsOptions || [] },
        { label: t('featuredCollections'), options: featuredCollectionsOptions || [] }
      ]}
      selectedOption={selectedOptions}
      onApply={() => {
        addQueries({ collectionIds: selectedOptions.map(o => o.value) });
      }}
      styles={{
        placeholder: (provided, state) => {
          if (state.hasValue) {
            return {
              ...provided,
              color: '#0D1E46',
              fontWeight: 700
            };
          }
          return { ...provided, color: '#475F8B' };
        }
      }}
      hasMenuSearch
      searchPlaceholder={t('searchCollections')}
      isMulti
      onChange={setSelectedOptions}
      controlWidth={160}
    />
  );
}

export { CollectionFilter };
